import { USER_CONTEXT_TOKEN_KEY } from './d-user-context.helper';

/**
 * Helper to build custom context and authorization headers for requests
 * that bypass Angular's HttpClient (e.g. Apollo upload links, Mapbox transformRequest).
 *
 * @param token - The Okta access token string (optional).
 * @returns A dictionary of custom headers to append to the outbound request.
 */
export function buildCustomHeaders(
  token?: string,
  contextTokenOverride?: string | null
): Record<string, string> {
  const contextToken: string | null =
    contextTokenOverride !== undefined
      ? contextTokenOverride
      : typeof window !== 'undefined' && typeof localStorage !== 'undefined'
        ? localStorage.getItem(USER_CONTEXT_TOKEN_KEY)
        : null;

  const customHeaders: Record<string, string> = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(contextToken ? { 'X-Deighton-User-Context': contextToken } : {})
  };

  return customHeaders;
}
